import { Controller } from "@hotwired/stimulus"

// The Manage Conversions ad-account select. Lives at the platform-tab level and drives every
// per-ad-account frame in the tab (the actions master-detail AND the funnel pane) — each frame
// target carries its own data-base-url + data-frame-prefix, since each response wraps itself in
// a `<prefix>-<ad_account_id>` turbo frame. A lazy frame that's inside a hidden pane keeps its
// deferred loading; setting src while hidden is fine.
export default class extends Controller {
  static targets = ["select", "frame"]
  static values = {
    provider: String
  }

  change() {
    const adAccountId = this.selectTarget.value
    if (!adAccountId) return

    this.frameTargets.forEach((frame) => {
      const url = new URL(frame.dataset.baseUrl, window.location.origin)
      url.searchParams.set("ad_account_id", adAccountId)
      url.searchParams.set("provider", this.providerValue)

      frame.id = `${frame.dataset.framePrefix}-${adAccountId}`
      frame.src = url.toString()
    })
  }
}
